import type { Finger } from "@otto/lehrgang";

/**
 * Fasst die Fingerfarben für die Legende zusammen.
 *
 * Gruppiert nach Farbe, damit die Kinder „grün heißt Mittelfinger“ lernen und
 * nicht neun Einzeleinträge lesen müssen: linke und rechte Hand teilen sich
 * ihre Farben, nur die Zeigefinger haben eigene.
 *
 * Vor dem Umdrehen des Fingermodells stand hier viermal so viel Code: das
 * Bundle listete je TASTE einen Eintrag, und die Finger mussten daraus mit
 * Regex zurückgewonnen werden – samt „(nach rechts)“ und Doppeldeutigkeiten.
 * Geblieben ist das Zusammenfassen selbst, denn das ist eine Frage der Anzeige
 * und keine der Daten.
 */
export function legendEntries(
  fingers: readonly Finger[],
): readonly { readonly color: string; readonly name: string }[] {
  const byColor = new Map<string, string[]>();
  for (const finger of fingers) {
    byColor.set(finger.color, [...(byColor.get(finger.color) ?? []), finger.name]);
  }
  return [...byColor].map(([color, names]) => ({ color, name: shared(names) }));
}

/** „linker kleiner Finger“ + „rechter kleiner Finger“ → „kleiner Finger“. */
function shared(names: readonly string[]): string {
  if (names.length === 1) return names[0]!;
  const withoutSide = names.map((n) => n.replace(/^(linker|rechter)\s+/, ""));
  return withoutSide.every((n) => n === withoutSide[0])
    ? withoutSide[0]!
    : names.join(" / ");
}
